// security.service.ts
import { Injectable } from '@angular/core';

import { DevToolsDetectService } from './dev-tools-detect.service';
import { environment } from '../../../environments/environment';
import { AccountService } from '../../core/http-services/account.service';
@Injectable({
    providedIn: 'root'
})

export class SecurityService {
    constructor(
        private readonly devToolsService: DevToolsDetectService,
        private readonly accountService: AccountService,
    ) { }

    enableSecurity(): void {
        if (!environment.production) return;

        this.devToolsService.devToolsStatus.subscribe((open) => {
            if (open) {
                alert('DevTools detected! Logging out...');
                this.accountService.logout();
                window.open('/auth/sign-in');
            }
        });

        document.addEventListener('contextmenu', (event) => {
            event.preventDefault();
        });

        document.addEventListener('keydown', (event: KeyboardEvent) => {
            if (
                event.key === 'F12' ||
                (event.ctrlKey && event.shiftKey && (event.key === 'I' || event.key === 'J')) ||
                (event.ctrlKey && event.key === 'U')
            ) {
                event.preventDefault();
            }
        });

        document.addEventListener('copy', (event) => {
            if (this.isPasteAllowed(event)){
                return;
            }
            event.preventDefault();
        });

        document.addEventListener('paste', (event) => {
            if (this.isPasteAllowed(event)){
                return;
            }
            event.preventDefault();
        });
    }

    /**
     * Copy/paste is blocked app-wide in production (see the 'copy' and 'paste'
     * listeners in enableSecurity). The only exception is any element marked with
     * the `data-allow-paste` attribute, which skips the block.
     * Currently used on the coupon code input in the Payment Process page (Subscription).
     */

    private isPasteAllowed(event: Event): boolean {
        const target = event.target as HTMLElement | null;
        return !!target?.closest?.('[data-allow-paste]');
    }
}
